import ApiConstants from "../constants/ApiConstants";
import http from "../http";
import ITable, { IColumn } from "../model/Table";

class Table {
  static getAllViews(): Promise<ITable[]> {
    return http.get(ApiConstants.URL.TABLE.GET_ALL).then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (err) => {
        return Promise.reject(err);
      }
    );
  }
  static getTable(tableId: string) {
    return http
      .get(`${ApiConstants.URL.TABLE.GET(tableId)}`)
      .then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error);
        }
      )
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  
  static getRecords(tableId: string) {
    return http
      .get(`${ApiConstants.URL.TABLE.GET_RECORD(tableId)}`)
      .then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error);
        }
      )
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  static getRecordsByPage(params: any, data: any, tableId: string) {
    if (!params) params = { pageNo: 1, pageSize: 20 };
    return http
      .post(`${ApiConstants.URL.TABLE.GET_RECORD_BY_PAGE(tableId)}`, data, 
      {
        params: {...params, _allowRetry: true }
      })
      .then(
        (response) => {
          response.data = response.data.map((record:any) => {
            return {
              ...record,
              cells: {
                ...record.cells,
                createdBy: record.createdBy,
                id: record._id,
              },
            };
          });
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error);
        }
      )
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  static getRecordById(recordId: string, tableId: string, params: any = {}) {
    return http
      .get(`${ApiConstants.URL.TABLE.GET_RECORD_BY_ID(recordId, tableId)}`, { params })
      .then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error);
        }
      )
      .catch((error) => {
        return Promise.reject(error);
      });
  }
}

export default Table;
